import axios from "axios";

export const getIpv6 = async (): Promise<string> => {
  return axios
    .get(`https://api64.ipify.org?format=json`)
    .then(({ data }) => data.ip || "")
    .catch(error => {
      throw new Error(`IPV6 error: ${error}`);
    });
};
